import {ChangeDetectionStrategy, Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faPencilSlash} from '@fortawesome/pro-regular-svg-icons';
import {TranslocoModule} from '@ngneat/transloco';

@Component({
  selector: 'pl-readonly-indicator',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, TranslocoModule],
  templateUrl: './readonly-indicator.component.html',
  styleUrls: ['./readonly-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReadonlyIndicatorComponent {
  constructor(lib: FaIconLibrary) {
    lib.addIcons(faPencilSlash);
  }
}
